import { useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import StudiesList from "./StudiesList";
// import LogoutContainer from "../Layout/LogoutContainer";
import { HeaderStyle } from "../Common/styles/header";
import { useAppSelector } from "../../Redux/hooks";
import { platformAdminPermissions } from "../../utils/roles";
import { dataTablePageShell } from "../../utils/dataTableShell";

const Studies = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const { platformPermissions } = useAppSelector((state) => state.user);
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.createStudy),
    [platformPermissions]
  );

  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          My Studies
        </Typography>

        {canEdit && (
          <Box sx={{ ml: "auto" }}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setOpenDrawer(true)}
            >
              New Study
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ p: 3, ...dataTablePageShell("calc(100% - 72px)") }}>
        <StudiesList
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          canEdit={canEdit}
          type="my-studies"
        />
      </Box>
    </>
  );
};

export default Studies;
